<section *ngIf="isOnAi" class="ai_bar isOnAi">
  <header>
    <section class="header-section">
      <section class="header-label" tabindex="0" aria-label="AI authorship">
        <img src="../../../../../../assets/report_v2/authorship_border.svg" alt="Back to summary analysis" />
        <section>
          <h2>{{ "general.authorship" | translate }}</h2>
          <span tabindex="0"
            aria-label="AI Authorship Index represents the level of text classified as AI-generated">The Authorship
            analysis examines potential AI generation, metadata issues, and comparative submission stylometrics to
            verify document authorship</span>
        </section>
      </section>
      <button (click)="toggleIsOnAi()" tabindex="0">
        <img src="../../../../../../assets/report_v2/arrow-right.svg" alt="Arrow left. Click to go to the Summary." />
      </button>
    </section>
  </header>

  <!-- New Stylometrics Section -->
  <section class="foldable-container new_feature" [class.disabled]="!stylometricsEnable"
    [class.new_feature_active]="isStylometricsFolded" *ngIf="stylometricsEnable">
    <button class="fold-header new_feature" (click)="toggleStylometricsFold()" [class.active]="!isStylometricsFolded">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="" />
          <h3>Stylometrics <span class="beta-tag">BETA</span></h3>
          <app-severity *ngIf="isStylometricsFolded && stylometricsEnable"
            [severityLevel]="averageStylisticDiscrepancy?.toLowerCase()" [text]="stylometricFlagsCount + ' Flags'">
          </app-severity>
        </section>
        <p>
          Provides a comparative analysis of current and past submission
          stylometrics to identify stylistic discrepancies.
          <a href="#" class="learn-more">Learn more</a>
        </p>
      </section>
      <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isStylometricsFolded"
        alt="Toggle Stylometrics" />
    </button>

    <section class="fold-content" [class.hidden]="isStylometricsFolded">
      <app-stylometrics [previousSubmissions]="previousSubmissions" [stylometricMetrics]="stylometricMetrics"
        [metricsThresholds]="metricsThresholds" [averageStylisticDiscrepancy]="averageStylisticDiscrepancy"
        [projectSynapse]="true" [projectSynapseData]="projectSynapseData" [analysisDate]="analysisDate"
        (discrepancyLevelChange)="onProjectSynapseDiscrepancyChange($event)">
      </app-stylometrics>
    </section>
  </section>

  <!-- Project Synapse -->
  <section class="foldable-container new_feature" *ngIf="projectSynapseEnable" [class.disabled]="!projectSynapseEnable"
    [class.new_feature_active]="isProjectSynapseFolded">
    <button class="fold-header new_feature" (click)="toggleProjectSynapseFold()"
      [class.active]="!isProjectSynapseFolded">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="" />
          <h3>AI Authorship (Advanced) <span class="beta-tag">BETA</span></h3>
          <app-severity *ngIf="isProjectSynapseFolded && projectSynapseEnable"
            [severityLevel]="projectSynapseStylisticDiscrepancy || averageStylisticDiscrepancy?.toLowerCase()"
            [text]="(projectSynapseStylisticDiscrepancy || averageStylisticDiscrepancy) | titlecase">
          </app-severity>
        </section>
        <p>
          Generates AI-simulated variants of submission content, compares their stylometrics to those of the original
          submission, and uses a built-in AI model to detect potential AI generation
          <!-- <a href="#" class="learn-more">Learn more</a> -->
        </p>
      </section>
      <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isProjectSynapseFolded"
        alt="Toggle Project Synapse" />
    </button>

    <section class="fold-content" [class.hidden]="isProjectSynapseFolded">
      <app-stylometrics [previousSubmissions]="previousSubmissions" [stylometricMetrics]="stylometricMetrics"
        [metricsThresholds]="metricsThresholds" [averageStylisticDiscrepancy]="averageStylisticDiscrepancy"
        [projectSynapse]="true" [projectSynapseData]="projectSynapseData" [analysisDate]="analysisDate"
        (discrepancyLevelChange)="onProjectSynapseDiscrepancyChange($event)">
      </app-stylometrics>
    </section>
  </section>

  <!-- Metadata Section -->
  <section class="foldable-container" *ngIf="metadataEnable">
    <button class="fold-header" (click)="toggleMetadataFold()" [class.active]="!isMetadataFolded">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/metadata_logo.svg" alt="" />
          <h3>{{ "metadata.metadata_analysis" | translate }}</h3>
          <app-severity *ngIf="isMetadataFolded" [severityLevel]="metadataIssues > 0 ? 'high' : 'low'"
            [text]="metadataIssues + ' ' + ('metadata.issues' | translate)">
          </app-severity>
        </section>
        <p>{{ "metadata.metadata_examination" | translate }}</p>
      </section>
      <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isMetadataFolded"
        alt="Toggle Metadata" />
    </button>

    <section class="fold-content" [class.hidden]="isMetadataFolded">
      <app-metadata [author]="author" [canEdit]="canEdit" [metadata]="metadata" [metadataUrl]="metadataUrl"
        (flagsChanged)="onFlagsChanged($event)" (refreshRequested)="onMetadataRefreshRequested()">
      </app-metadata>
    </section>
  </section>

  <!-- Old AI Analysis -->
  <section class="foldable-container" [disabled]="!aiAnalysis?.checkAI" [class.disabled]="!aiAnalysis?.checkAI"
    *ngIf="simpleAIEnable">
    <button class="fold-header" (click)="toggleAiFold()" [class.active]="!isAiFolded || !aiAnalysis?.checkAI">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/ai-authorship_borderless.svg" alt="AI Analysis" />
          <h3>{{ "general.ai_authorship" | translate }}</h3>
        </section>
        <p>{{ "metadata.ai_generated_content" | translate }}</p>
      </section>
      <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isAiFolded"
        alt="Toggle AI Analysis" />
    </button>

    <section class="fold-content" [class.hidden]="isAiFolded || !aiAnalysis?.checkAI">
      <section tabindex="0" class="similarity_overview" [ariaLabel]="
          'Document has ' + aiAnalysis?.aiPercentage + '% AI similarity'
        ">
        <p class="ai_similarity_percent">
          {{ "new_entries.ai_authorship_index" | translate }}
        </p>
        <div>
          <mat-progress-bar title="Progress Bar" id="ai" mode="determinate" [value]="aiAnalysis?.aiPercentage"
            color="#462D86"></mat-progress-bar>
          <p class="paragraphStyle">{{ aiAnalysis?.aiPercentage }}%</p>
        </div>
      </section>
      <section class="ai_score" tabindex="0">
        <div class="alert_img">
          <img src="../../../../../../assets/report_v2/warning-circled-filled-ai.svg" alt="Alert icon" />
        </div>
        <h3 *ngIf="aiAnalysis?.aiPercentage >= 0 && aiAnalysis?.aiPercentage < 15" [innerHTML]="ai_percentage.low">
          {{ "new_entries.low" | translate }}
        </h3>
        <h3 *ngIf="
            aiAnalysis?.aiPercentage >= 15 && aiAnalysis?.aiPercentage < 35
          " [innerHTML]="ai_percentage.medium">
          {{ "new_entries.medium" | translate }}
        </h3>
        <h3 *ngIf="
            aiAnalysis?.aiPercentage >= 35 && aiAnalysis?.aiPercentage <= 100
          " [innerHTML]="ai_percentage.high">
          {{ "new_entries.high" | translate }}
        </h3>
      </section>
      <section class="insights" aria-label="Insights">
        <header class="insights_header" tabindex="0">
          <img src="../../../../../../assets/report_v2/ai-insights.svg" alt="" />
          <h4>{{ "new_entries.insights" | translate }}</h4>
        </header>
        <section class="insights_section" tabindex="0" aria-label="Insights Body">
          <section class="total_sentences" tabindex="0"
            [ariaLabel]="'The number of total sentences is: ' + totalSentences">
            <h5>{{ "report.total_sentences" | translate }}</h5>
            <p>{{ totalSentences }}</p>
          </section>
          <section class="ai_sentences" tabindex="0" [ariaLabel]="
              'The number of AI-written sentences is: ' + aiSentences
            ">
            <h5>{{ "new_entries.ai_written_sentences_count" | translate }}:</h5>
            <p>{{ aiSentences }}</p>
          </section>
          <section class="human_sentences" tabindex="0" [ariaLabel]="
              'The number of human-written sentences is: ' + humanSentences
            ">
            <h5>
              {{ "new_entries.human_written_sentences_count" | translate }}:
            </h5>
            <p>{{ humanSentences }}</p>
          </section>
        </section>
      </section>
      <app-overview-disclaimer tabindex="0" [title]="'general.overview' | translate" [disclaimerText]="
          'new_entries.ai_authorship_index_description_2' | translate
        " [disclaimerLink]="
          'https://support.inspera.com/hc/en-us/articles/25465381384349-Authorship-Analysis-In-Depth'
        " [linkText]="'new_entries.learn_more' | translate"></app-overview-disclaimer>
    </section>
  </section>
</section>

<section *ngIf="!isOnAi && (simpleAIEnable || metadataEnable || stylometricsEnable || projectSynapseEnable)"
  class="ai_bar">
  <header>
    <section class="header-section">
      <section class="header-label" tabindex="0" aria-label="AI authorship">
        <img src="../../../../../../assets/report_v2/authorship_border.svg" alt="Open AI authorship analysis" />
        <section>
          <h2>{{ "general.authorship" | translate }}</h2>
          <span tabindex="0"
            aria-label="AI Authorship Index represents the level of text classified as AI-generated">The Authorship
            analysis examines potential AI generation, metadata issues, and comparative submission stylometrics to
            verify document authorship</span>
        </section>
      </section>
      <button (click)="toggleIsOnAi()" tabindex="0">
        <span>{{ "metadata.go_to_details" | translate }}</span>
        <img src="../../../../../../assets/report_v2/arrow-right.svg"
          alt="Arrow right. Click to go to the AI authorship analysis." />
      </button>
    </section>
  </header>

  <section class="similarity_overview" [ariaLabel]="'Document has ' + aiAnalysis?.aiPercentage + '% AI similarity'"
    tabindex="0" *ngIf="stylometricsEnable">
    <div class="overview-head">
      <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="Metadata Icon" />
      <section class="overview">
        <div tabindex="0">
          <span>Stylistic Discrepancy:</span><span class="answ">{{ averageStylisticDiscrepancy }}</span>
        </div>
        <div tabindex="0">
          <span>Flagged Metrics:</span><span class="answ"
            title="Number of metrics that differ significantly from previous submissions">{{ stylometricFlagsCount
            }}</span>
        </div>
      </section>
      <div class="overview-tag stylometric">
        <p class="tag" [ngClass]="averageStylisticDiscrepancy.toLowerCase()"
          title="Metrics exceeding difference thresholds from previous submissions"><span class="round"></span>{{
          stylometricFlagsCount }} Flags</p>
      </div>
      <div class="overview-arrow">
        <button (click)="navigateToStylometrics()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Fast arrow">
        </button>
      </div>
    </div>
  </section>
  <section class="similarity_overview" [ariaLabel]="'Document has ' + aiAnalysis?.aiPercentage + '% AI similarity'"
    tabindex="0" *ngIf="simpleAIEnable">
    <div class="overview-head">
      <img src="../../../../../../assets/report_v2/ai-authorship_borderless.svg" alt="" />
      <section class="overview">
        <div tabindex="0">
          <span>{{ "new_entries.ai_written_sentences_count" | translate }}:</span><span class="answ">{{ aiSentences
            }}</span>
        </div>
        <div tabindex="0">
          <span>{{
            "new_entries.human_written_sentences_count" | translate
            }}:</span><span class="answ">{{ humanSentences }}</span>
        </div>
      </section>
      <div *ngIf="originalityDisplay !== 'None'" class="overview-tag">
        <p *ngIf="originalityDisplay === 'Percentage'" class="tag" [ngClass]="getAiRiskLevel()">
          <span class="round"></span>
          {{ aiAnalysis?.aiPercentage?.toFixed(2) || '0' }}%
        </p>

        <p *ngIf="originalityDisplay === 'riskFactor'" class="tag" [ngClass]="getAiRiskLevel()">
          <span class="round"></span>
          {{
          (aiAnalysis?.aiPercentage >= 35
          ? 'new_entries.high_probability'
          : aiAnalysis?.aiPercentage >= 15
          ? 'new_entries.moderate_probability'
          : 'new_entries.low_probability') | translate
          }}
        </p>
      </div>


      <div class="overview-arrow">
        <button (click)="navigateToAi()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Fast arrow">
        </button>
      </div>
    </div>
  </section>

  <section class="similarity_overview" [ariaLabel]="'Document has ' + aiAnalysis?.aiPercentage + '% AI similarity'"
    tabindex="0" *ngIf="projectSynapseEnable">
    <div class="overview-head">
      <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="Metadata Icon" />
      <section class="overview">
        <div tabindex="0">
          <span>AI Authorship (Advanced):</span><span class="answ">{{ getMostProbableModelStatus() }}</span>
        </div>
      </section>
      <div class="overview-tag stylometric">
        <p class="tag" [ngClass]="getMostProbableModelClass()"><span class="round"></span>{{
          getMostProbableModelPercentage() > 100 ? 100 : getMostProbableModelPercentage() }}%</p>
      </div>
      <div class="overview-arrow">
        <button (click)="navigateToProjectSynapse()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Fast arrow">
        </button>
      </div>
    </div>
  </section>

  <section class="similarity_overview" [ariaLabel]="'Document has ' + aiAnalysis?.aiPercentage + '% AI similarity'"
    tabindex="0" *ngIf="metadataEnable">
    <div class="overview-head">
      <img src="../../../../../../assets/report_v2/metadata_logo.svg" alt="Metadata Icon" />
      <section class="overview">
        <div tabindex="0">
          <span>{{ "metadata.total_metadata" | translate }}:</span><span class="answ">{{ metadataLength }}</span>
        </div>
      </section>
      <div *ngIf="originalityDisplay !== 'None'" [ngClass]="metadataIssues > 0 ? 'high' : 'low'">
        <p class="tag" [ngClass]="metadataIssues > 0 ? 'high' : 'low'">
          <span class="round"></span>{{ metadataIssues }}
          {{ "metadata.issues" | translate }}
        </p>
      </div>
      <div class="overview-arrow">
        <button (click)="navigateToMetadata()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Fast arrow">
        </button>
      </div>
    </div>
  </section>
</section>